import { z } from "zod";
import { gql } from "graphql-request";
import { ImageSchema, ImageFragment } from "./image";

export const SocialLinkSchema = z.object({
  linkUrl: z.string().nullable(),
  linkLocale: z.string().nullable(),
  linkPage: z.string().nullable(),
  socialLinkImage: ImageSchema.nullable(),
  socialLinkImageEn: ImageSchema.nullable(),
});

export const SocialLink = SocialLinkSchema;
export type SocialLink = z.infer<typeof SocialLinkSchema>;

export const SocialLinkFragment = gql`
  fragment SocialLinkFragment on SocialLink {
    linkUrl
    linkLocale
    linkPage

    socialLinkImage {
      ...ImageFragment
    }
    socialLinkImageEn: socialLinkImage(locale: "en") {
      ...ImageFragment
    }
  }

  ${ImageFragment}
`;
